namespace Portico.Models.Legacy {

    export class PhoneNumberModel {
        phoneNumberId: number;
        countryCode: string;
        areaCode: string;
        number: string;
        primaryPhoneNumber: boolean;
        phoneType: number;
        extension: string;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.PhoneNumberModel) {
            this.phoneNumberId = null;
            this.countryCode = null;
            this.areaCode = null;
            this.number = null;
            this.primaryPhoneNumber = null;
            this.phoneType = null;
            this.extension = null;

            if(obj) {
                this.phoneNumberId = obj.phoneNumberId || null;
                this.countryCode = obj.countryCode || null;
                this.areaCode = obj.areaCode || null;
                this.number = obj.number || null;
                this.primaryPhoneNumber = obj.primaryPhoneNumber || null;
                this.phoneType = obj.phoneType || null;
                this.extension = obj.extension || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.PhoneNumberModel {
            return {
                phoneNumberId: this.phoneNumberId,
                countryCode: this.countryCode,
                areaCode: this.areaCode,
                number: this.number,
                primaryPhoneNumber: this.primaryPhoneNumber,
                phoneType: this.phoneType,
                extension: this.extension,
            };
        }
    }
}